import { render } from "./Genre.vue?vue&type=template&id=425c8f76"
import script from "./Genre.vue?vue&type=script&lang=js"
export * from "./Genre.vue?vue&type=script&lang=js"

import "./Genre.vue?vue&type=style&index=0&id=425c8f76&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__